import axios from 'axios';
import config from '../config/default';

export default () => axios.create({ baseURL: config.baseURL });